<template>
  <datetime-popup
    v-if="isOpen"
    key="popup"
    :type="type"
    :datetime="popupDate"
    @confirm="confirm"
    @cancel="close"
  >
    <template
      slot="button-cancel__internal"
      slot-scope="scope"
    >
      <slot
        name="button-cancel"
        :step="scope.step"
      >取消</slot>
    </template>
    <template
      slot="button-confirm__internal"
      slot-scope="scope"
    >
      <slot
        name="button-confirm"
        :step="scope.step"
      >確定</slot>
    </template>
  </datetime-popup>
</template>
<script>
import { DateTime } from '~luxon'
import DatetimePopup from '~components/third-party/vue-datetime/DatetimePopup'
import { datetimeFromISO } from '~components/third-party/vue-datetime/util'
export default {
  name: 'InternFormDatetimePopup',
  components: {
    DatetimePopup,
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'date'
    },
    format: {
      type: [Object, String],
      default: null
    },
  },
  computed: {
    popupDate () {
      return this.datetime ? this.datetime.setZone(this.zone) : this.newPopupDatetime()
    },
  },
  data () {
    return {
      datetime: null,
    };
  },
  watch: {
    value (newValue) {
      this.datetime = datetimeFromISO(newValue)
    },
    isOpen (value) {
      if (value) this.$store.commit('layouts/setModalBackdropOpen');
      else this.$store.commit('layouts/setModalBackdropClose');
    },
  },
  created () {
    this.datetime = datetimeFromISO(this.value);
    this.$store.commit('layouts/setModalBackdropClose');
  },
  methods: {
    inputValue () {
      let format = this.format

      if (!format) {
        switch (this.type) {
          case 'date':
            format = DateTime.DATE_MED // TODO: 汰換 luxon
            break
          case 'time':
            format = DateTime.TIME_24_SIMPLE // TODO: 汰換 luxon
            break
          case 'datetime':
          case 'default':
            format = DateTime.DATETIME_MED // TODO: 汰換 luxon
            break
        }
      }

      if (typeof format === 'string') {
        return this.datetime ? DateTime.fromISO(this.datetime).setZone(this.zone).toFormat(format) : '' // TODO: 汰換 luxon
      } else {
        return this.datetime ? this.datetime.setZone(this.zone).toLocaleString(format) : ''
      }
    },
    newPopupDatetime () {
      return DateTime.utc().setZone(this.zone).set({ seconds: 0, milliseconds: 0 });
    },
    close() {
      this.$emit('close');
    },
    confirm (datetime) {
      this.datetime = datetime.toUTC();
      let new_value = this.inputValue();
      this.close();
      this.$emit('confirm', new_value);
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
